export * from './abstract.entity';



// WEBPACK FOOTER //
// ./src/app/shared/entities/abstract/index.ts